export interface ConnectionState {
  isOnline: boolean;
  lastChecked: number | null;
}

export const initialState: ConnectionState = {
  isOnline: true,
  lastChecked: null,
};
